<template>
    <div
      class="modal modalFade userModels reportRateModal"
      id="report_rate_modal"
      tabindex="-1"
      aria-labelledby="userModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="modal-title" id="userModalLabel">ابلاغ عن تقييم</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            ></button>
          </div>
          <!-- Modal Body -->
          <div class="modal-body">
            <h3 class="text_1">قدم بلاغ</h3>
            <form id="addIssueForm" @submit.prevent="handleSubmit">
         
              <!-- Issue Notes -->
              <div class="input-group">
                <textarea
                  name="issue_notes"
                  id="issue_notes"
                  class="form-control"
                  placeholder="وصف الابلاغ"
                  rows="7"
                  v-model="comment"
                ></textarea>
                <span v-if="errors.comment" class="has-error text-danger w-100">
                  {{ errors.comment }}
                </span>
              </div>
              <!-- Submit Button -->
              <div class="input-group mb-0">
                <button
                  id="addIssueFormBTN"
                  type="submit"
                  class="form-control has-spinner-link"
                >
                  <div class="button_text"> ارسال </div>
                </button>
              </div>
            </form>
          </div>
          <!-- End Modal Body -->
        </div>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  import { ref, reactive } from 'vue'
  import { useBootstrapModal } from '@/composables/useBootstrapModal'
  import { useNuxtApp } from '#app'
  import { useGlobalAlert } from '~/composables/useGlobalAlert'
  
  // الحصول على الـ API instance
  const { $api } = useNuxtApp()
  // الحصول على الدالة الخاصة بعرض التنبيهات
  const { showAlert } = useGlobalAlert()
  
  // استخدام الـ bootstrap modal helper
  const { openModal, closeModal } = useBootstrapModal('report_rate_modal')
  
  // المتغيرات التفاعلية لتخزين معرف التقييم والتعليق
  const ratingId = ref<string>('')
  const comment = ref<string>('')
  
  // كائن لتخزين رسائل الخطأ
  const errors = reactive({
    comment: ''
  })
  
  // السماح للـ parent component بضبط معرف التقييم وفتح المودال
  defineExpose({
    setRatingId(id: string) {
        ratingId.value = id
    },
    openModal,
  })
  
  // دالة إرسال الطلب للإبلاغ عن التقييم
  const handleSubmit = async () => {
    // إعادة تعيين رسالة الخطأ
    errors.comment = ''
  
    // التحقق من وجود تعليق وعدم تجاوزه 5000 حرف
    if (!comment.value.trim()) {
      errors.comment = 'الرجاء كتابة وصف للابلاغ'
      return
    }
    if (comment.value.length > 5000) {
      errors.comment = 'الحد الاقصى لعدد الاحرف هو 5000'
      return
    }
  
    try {
        
      // إرسال الطلب إلى API باستخدام طريقة POST مع إرسال التعليق في الـ body
      const response = await $api<{ status: boolean; message: string }>(
        `ratings/${ratingId.value}/complaints`,
        {
          method: 'POST',
          body: JSON.stringify({ comment: comment.value.trim() }),
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
  
      // التحقق من نجاح العملية
      if (response.status === true) {
        closeModal()
        showAlert('تم اضافة الشكوى بنجاح', 'success')
        setTimeout(() => {
          reloadNuxtApp();
        }, 1000);
        // إعادة تعيين قيمة التعليق
        comment.value = ''
      } else {
        errors.comment = response.message || 'حدث خطأ ما، الرجاء المحاولة مرة أخرى'
      }
    } catch (error: any) {
      console.error('Error reporting complaint', error)
      errors.comment = error.data?.message || 'حدث خطأ ما، الرجاء المحاولة مرة أخرى'
    }
  }
  </script>
  